// TODO: after add redux, this file must remove!

const photographers = {
	data: [
		{
			id: 2394,
			first_name: 'محمد',
			last_name: 'جاجرمی',
			avatar:
        '/uploads/photographer/avatar/2394/%D9%85%D8%AD%D9%85%D8%AF_%D8%AC%D8%A7%D8%AC%D8%B1%D9%85%DB%8C.jpg',
			gender: 2,
			rate: 4.737980769230769,
			price: '0',
			attachments: [
				'/uploads/photographer_attachment/avatar/291/DSC_9401.jpg',
				'/uploads/photographer_attachment/avatar/292/IMG_8448.jpg',
				'/uploads/photographer_attachment/avatar/293/kopi.jpg',
				'/uploads/photographer_attachment/avatar/294/5.jpg',
				'/uploads/photo/file/27160/_MG_1753.jpg',
				'/uploads/photo/file/27161/_MG_2168.jpg',
				'/uploads/photo/file/27162/_MG_9339.jpg',
				'/uploads/photo/file/27163/_MG_9343.jpg',
			],
			photos: [
				'/uploads/photo/file/7420/LRM_EXPORT_20180527_141405.jpg',
				'/uploads/photo/file/7421/LRM_EXPORT_20180126_180531.jpg',
				'/uploads/photo/file/7422/3E6A1589.jpg',
				'/uploads/photo/file/7423/3E6A9289_1_-01.jpg',
			],
			stduio_address_detail: 'میدان انقلاب ابتدای کارگر جنوبی ب ...',
			studio_photos: [],
			distance_to_you: 5,
		},
		{
			id: 3825,
			first_name: 'بهنام',
			last_name: 'چیت سازان',
			avatar:
        '/uploads/photographer/avatar/3825/inbound6173451375789400514.jpg',
			gender: 2,
			rate: 4.340909090909091,
			price: '0',
			attachments: [
				'/uploads/photographer_attachment/avatar/1017/DSC_1047.jpg',
				'/uploads/photographer_attachment/avatar/1019/IMG_5729.jpg',
				'/uploads/photographer_attachment/avatar/1020/BCS_0023.jpg',
				'/uploads/photographer_attachment/avatar/1018/DSC_1024.jpg',
				'/uploads/photo/file/49007/inbound1668864841322714483.jpg',
				'/uploads/photo/file/49008/inbound4452483267943154857.jpg',
				'/uploads/photo/file/49009/inbound5972194299941823796.jpg',
				'/uploads/photo/file/49010/inbound628481294594464151.jpg',
			],
			stduio_address_detail:
        'شهرک غرب.خیابان فرحزادی.پایین تر ازنیایش.خیابان عباسی  ...',
			studio_photos: [],
			distance_to_you: 0,
			photos: [
				'/uploads/photo/file/7420/LRM_EXPORT_20180527_141405.jpg',
				'/uploads/photo/file/7421/LRM_EXPORT_20180126_180531.jpg',
				'/uploads/photo/file/7422/3E6A1589.jpg',
				'/uploads/photo/file/7423/3E6A9289_1_-01.jpg',
			],
		},
		{
			id: 356,
			first_name: 'پویا',
			last_name: 'تاریوردی',
			avatar: '/uploads/photographer/avatar/356/3E6A6507-Recovered.jpg',
			gender: 2,
			rate: 4.6838235294117645,
			price: '0',
			attachments: null,
			comments_count: 86,
			photos: [
				'/uploads/photo/file/7420/LRM_EXPORT_20180527_141405.jpg',
				'/uploads/photo/file/7421/LRM_EXPORT_20180126_180531.jpg',
				'/uploads/photo/file/7422/3E6A1589.jpg',
				'/uploads/photo/file/7423/3E6A9289_1_-01.jpg',
			],
			stduio_address_detail: 'تهران بلوار دریا بین صرافها و سعادت آبا ...',
			studio_photos: [
				'/uploads/shoot_location_attachment/photo/567/IMG-20201125-WA0019.jpg',
				'/uploads/shoot_location_attachment/photo/568/IMG-20201125-WA0020.jpg',
				'/uploads/shoot_location_attachment/photo/569/IMG-20201125-WA0025.jpg',
				'/uploads/photographer/avatar/2641/IHK_5091.jpg',
				'/uploads/photographer_attachment/avatar/420/Untitled-1.jpg',
				'/uploads/photographer_attachment/avatar/421/65.jpg',
				'/uploads/photographer_attachment/avatar/422/77.jpg',
				'/uploads/photographer_attachment/avatar/423/99.jpg',
				'/uploads/photo/file/31316/DSC_1356.jpg',
				'/uploads/photo/file/31317/DSC_13751.jpg',
				'/uploads/photo/file/31319/DSC_1459.jpg',
				'/uploads/photo/file/31320/_DSC08451.jpg',
			],
			distance_to_you: 9,
		},
		{
			id: 4722,
			first_name: 'میلاد',
			last_name: 'شمس',
			avatar: '/uploads/photographer/avatar/4722/3.jpg',
			gender: 2,
			rate: 3.75,
			price: '0',
			attachments: null,
			comments_count: 2,
			photos: [
				'/uploads/photo/file/67785/DSC_6649.jpg',
				'/uploads/photo/file/67795/DSC_2679.jpg',
				'/uploads/photo/file/67796/DSC_5674.jpg',
				'/uploads/photo/file/67804/DSC_6322.jpg',
			],
			stduio_address_detail:
        'پونک - سیمون بولیوار - خیابان چمران -   جنب کوچه دوم غ ...',
			studio_photos: [],
			distance_to_you: 0,
		},
	],
	isStudio: true,
	isNear: true,
	feed_backs: [
		{
			text: 'حرفه ای',
			quality: 10,
			service: 10,
			user: 'کادرو سامانه درخواست عکاسی',
			shoot_type: 'خبری و رویداد',
			start_time: 'آذر 1398',
			duration: 4.0,
			photo_counts: 1078,
		},
		{
			text: 'تاریوردی رو به دلیل انرژی خوب در عکاسی بهتون پیشنهاد میکنم',
			quality: 10,
			service: 10,
			user: 'محمد افشاری',
			shoot_type: 'پوشاک و لباس',
			start_time: 'دی 1398',
			duration: 5.0,
			photo_counts: 324,
		},
		{
			text: 'دقيق سر وقت و كارشون عالى',
			quality: 10,
			service: 10,
			user: 'سپيده دژدار',
			shoot_type: 'چهره - پروفایل',
			start_time: 'دی 1398',
			duration: 1.0,
			photo_counts: 129,
		},
		{
			text: 'فوق العاده با اخلاق، حرفه ای و صبور',
			quality: 10,
			service: 10,
			user: 'علی یعسوبی',
			shoot_type: 'چهره - پروفایل',
			start_time: 'بهمن 1398',
			duration: 2.0,
		},
		{
			text: 'حضوربه موقع و دقت بالا وخوش اخلاق بودن \r\n\r\n',
			quality: 10,
			service: 10,
			user: 'هنگامه همتی',
			shoot_type: 'غذا و رستورانی',
			start_time: 'بهمن 1398',
			duration: 2.0,
			photo_counts: 163,
		},
		{
			text:
        'یه عکاس پر انرژی و همه چی تموم که خیلی با حوصله وقت میذاره و با دقت عکسا رو میگیره.',
			quality: 10,
			service: 10,
			user: 'محسن دهنوی ',
			shoot_type: 'عقد و عروسی',
			start_time: 'اسفند 1398',
			duration: 1.0,
			photo_counts: 185,
		},
		{
			text: 'خوش برخورد و صبور',
			quality: 10,
			service: 10,
			user: 'سعید توکلی',
			shoot_type: 'چهره - پروفایل',
			start_time: 'فروردین 1399',
			duration: 1.0,
			photo_counts: 121,
		},
		{
			text: 'بسیار خلاق و ایده های مناسب با محیط، خوش انرژی ',
			quality: 10,
			service: 10,
			user: 'امیرحسین یوسفی',
			shoot_type: 'چهره - پروفایل',
			start_time: 'اردیبهشت 1399',
			duration: 1.0,
			photo_counts: 67,
		},
		{
			text: 'پ تاروردی خیلی خوب است',
			quality: 10,
			service: 10,
			user: 'آرمان اله وردی',
			shoot_type: 'غذا و رستورانی',
			start_time: 'خرداد 1399',
			duration: 3.0,
			photo_counts: 5,
		},
		{
			text:
        'تاریوردی با حوصله  و وظیفه شناس و مودب هست. به موقع اومد و خیلی با حوصله کارا رو انجام داد و عکسای خوبی بهمون تحویل داد.',
			quality: 10,
			service: 10,
			user: 'امینه اوسطی',
			shoot_type: 'تیمی و شرکتی',
			start_time: 'خرداد 1399',
			duration: 1.5,
			photo_counts: 23,
		},
		{
			text:
        'تاریوردی تو کارش حرفه ایه و اگر میخواید ی کار خوب تحویل بگیرید همه چیز رو به خودش بسپارید. با دقت و خلاق هستش و تجهیزاتش کامله ',
			quality: 10,
			service: 10,
			user: 'میلاد موسوی',
			shoot_type: 'تبلیغاتی-محصول',
			start_time: 'خرداد 1399',
			duration: 7.0,
			photo_counts: 443,
		},
		{
			text: 'م',
			quality: 10,
			service: 10,
			user: 'مجتبی بیگدلی',
			shoot_type: 'تبلیغاتی-محصول',
			start_time: 'تیر 1399',
			duration: 2.0,
			photo_counts: 52,
		},
		{
			text: 'خوش برخورد و با دقت بالا',
			quality: 9,
			service: 10,
			user: 'عرفان شهرابی',
			shoot_type: 'چهره - پروفایل',
			start_time: 'تیر 1399',
			duration: 1.0,
			photo_counts: 121,
		},
		{
			text: 'بسیار عالی و دقیق و با حوصله ',
			quality: 10,
			service: 10,
			user: 'امینه اوسطی',
			shoot_type: 'تیمی و شرکتی',
			start_time: 'تیر 1399',
			duration: 1.5,
			photo_counts: 29,
		},
		{
			text: 'بسیار منظم و با دقت',
			quality: 10,
			service: 10,
			user: 'شیوا جلوه',
			shoot_type: 'خبری و رویداد',
			start_time: 'مرداد 1397',
			duration: 1.0,
			photo_counts: 86,
		},
		{
			text:
        'بسیار منظم و سر وقت در مکان حاضر شدند ، خوش اخلاق و برخورد . علم کافی و انعطاف پذیری . عکس های بسیار عالی . کاربلد و حرفه ای ',
			quality: 10,
			service: 10,
			user: 'امیرحسین نجاح',
			shoot_type: 'خبری و رویداد',
			start_time: 'آبان 1397',
			duration: 2.0,
			photo_counts: 174,
		},
		{
			text: 'بسيار با حوصله و خوش اخلاق بودن',
			quality: 10,
			service: 9,
			user: 'دلشاد',
			shoot_type: 'تبلیغاتی-محصول',
			start_time: 'تیر 1399',
			duration: 3.5,
			photo_counts: 292,
		},
		{
			text:
        'واقعا بی نظیر بودند آقای تاریوردی؛ انرژی ، وسواسی که روی کیفیت کار داشتند، خلاقیت ، صبر، حوصله. علاوه بر تمامی اینها برای دفعات آینده همکاری صد در صد انتخابی جز آقای تاریوردی نخواهیم داشت، و پیشنهاد میکنم حتما همکاری با ایشون رو تجربه کنید.',
			quality: 10,
			service: 10,
			user: 'بهرخ داوودی',
			shoot_type: 'تبلیغاتی-محصول',
			start_time: 'مرداد 1399',
			duration: 2.0,
			photo_counts: 57,
		},
		{
			text:
        'واقعا بی نظیر بودند آقای تاریوردی؛ انرژی ، وسواسی که روی کیفیت کار داشتند، خلاقیت ، صبر، حوصله. علاوه بر تمامی اینها برای دفعات آینده همکاری صد در صد انتخابی جز آقای تاریوردی نخواهیم داشت، و پیشنهاد میکنم حتما همکاری با ایشون رو تجربه کنید.',
			quality: 10,
			service: 10,
			user: 'بهرخ داوودی',
			shoot_type: 'تبلیغاتی-محصول',
			start_time: 'مرداد 1399',
			duration: 3.0,
			photo_counts: 10,
		},
		{
			text:
        'تاریوردی را بدلیل انرژی زیاد و حضور به موقع در محل و ادیت خوبی که روی عکس ها زد به دیگران توصیه می کنم.',
			quality: 10,
			service: 10,
			user: 'حسین رستمی',
			shoot_type: 'چهره - پروفایل',
			start_time: 'تیر 1399',
			duration: 1.5,
			photo_counts: 132,
		},
		{
			text:
        'عالیییی عالیییی \r\nچندین بار عکاسی کردیم‌و هر دفعه هم اقای تاریوردی رو انتخاب کردیم.',
			quality: 10,
			service: 10,
			user: 'بهرخ داوودی',
			shoot_type: 'تبلیغاتی-محصول',
			start_time: 'مهر 1399',
			duration: 2.0,
		},
		{
			text: 'بموقع،\r\nبا ذوق\r\nباحال\r\nمودب',
			quality: 10,
			service: 10,
			user: 'سعید انصاری',
			shoot_type: 'چهره - پروفایل',
			start_time: 'مرداد 1399',
			duration: 1.0,
			photo_counts: 259,
		},
		{
			text: 'با سپاس و تشکر از شما کادرو\r\n عالی بودن ',
			quality: 10,
			service: 10,
			user: 'سونیا علی اکبری',
			shoot_type: 'تبلیغاتی-محصول',
			start_time: 'تیر 1398',
			duration: 2.0,
			photo_counts: 20,
		},
		{
			text: 'خیلی خوب و با شخصیت',
			quality: 10,
			service: 10,
			user: 'حامد جم',
			shoot_type: 'معماری-فضای داخلی',
			start_time: 'مرداد 1398',
			duration: 7.0,
			photo_counts: 70,
		},
		{
			text:
        'خیلی پسر خوب و منظم و خوش اخلاقی بود.\r\nفقط نور عکس ها میتونست بهتر باشه و انتظارم این بود که از برگزارکننده ها عکس های قشنگ تر و بهتری بگیرد!\r\n',
			quality: 9,
			service: 10,
			user: 'محمد سبزعلی',
			shoot_type: 'خبری و رویداد',
			start_time: 'اردیبهشت 1398',
			duration: 3.0,
			photo_counts: 207,
		},
		{
			text: 'خیلی خوب',
			quality: 9,
			service: 10,
			user: 'مهدی رستمی',
			shoot_type: 'معماری-فضای داخلی',
			start_time: 'مرداد 1398',
			duration: 2.0,
			photo_counts: 8,
		},
		{
			text: 'پویا عاشق کارشه و با دقت حس مسئولیت زیادی کارش رو انجام میده!',
			quality: 10,
			service: 10,
			user: 'عرفان آریان منش',
			shoot_type: 'تبلیغاتی-محصول',
			start_time: 'شهریور 1398',
			duration: 3.0,
			photo_counts: 46,
		},
		{
			text:
        '                 آقای تاریوردی عکاسی حرفه ای صبوری بود. نتیجه کار واقعا لذت بخش بود.👍',
			quality: 10,
			service: 10,
			user: 'حجت اله بسطامی',
			shoot_type: 'تبلیغاتی-محصول',
			start_time: 'آذر 1398',
			duration: 3.0,
			photo_counts: 68,
		},
		{
			text: 'خداقوت',
			quality: 9,
			service: 9,
			user: 'محمد سبزعلی',
			shoot_type: 'خبری و رویداد',
			start_time: 'شهریور 1398',
			duration: 1.5,
			photo_counts: 179,
		},
		{
			text: 'Khoob',
			quality: 10,
			service: 10,
			user: 'سامان مرادي',
			shoot_type: 'چهره - پروفایل',
			start_time: 'شهریور 1398',
			duration: 1.0,
			photo_counts: 64,
		},
		{
			text: 'همکاری صبورانه و دقت در زمانبندی',
			quality: 10,
			service: 10,
			user: 'فریبا امینی',
			shoot_type: 'غذا و رستورانی',
			start_time: 'شهریور 1398',
			duration: 4.0,
			photo_counts: 264,
		},
		{
			text:
        'مثل همیشه با ایده های خوب و عملکرد منظم ایشان تجربه ی یک عکاسی خوب را داشتیم',
			quality: 10,
			service: 10,
			user: 'نسیم کی نژاد',
			shoot_type: 'پوشاک و لباس',
			start_time: 'مهر 1398',
			duration: 3.0,
			photo_counts: 20,
		},
	],
};

export default photographers;
